import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EraserRegular from './eraser-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EraserRegular {...validProps} />;
}

SvgComponent.iconName = 'eraserRegular';

export const EraserRegularIcon = svgIconWrapper(SvgComponent);
